export { createSwitchHandleMapping } from './createSwitchHandleMapping'
